/** @jsx jsx */
import { jsx, Styled } from "theme-ui";
import { Layout } from "components/common";
import Article from "components/article";
import { Helmet } from "react-helmet";
const Today = ({ today, showTodaysArticles, dispatch }) => {
  return (
    <Layout sx={{ py: "4" }}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>the5ive: an app which tracks my daily reading lists</title>
        <link rel="canonical" href="https://the5ive.now.sh" />
      </Helmet>
      <Styled.h2 sx={{ px: "3" }}>Today Lists: </Styled.h2>
      <div
        sx={{
          display: "grid",
          gridGap: 4,
          gridTemplateColumns: ["auto", "1fr 1fr 1fr"]
        }}
      >
        {today.map(article => {
          return <Article key={article.id} article={article} />;
        })}
      </div>
    </Layout>
  );
};

export default Today;
